import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const AmericanExpress = ({featuredProjectsList}) => {
  const project = getProject('american-express');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            video: '77064523',
            posterVideo: '215749415'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            For its annual American Express Fan Experience, Momentum invited us
            to help transform fans’ tennis swings into generative art with two
            distinct installations.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503195502/usopen-1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="art-sound-of-tennis">Art &amp; Sound of Tennis</h2>
          <p>
            At the “Art &amp; Sound of Tennis” installation, we customized
            tennis racquets with motion sensors for participants to swing as a
            crowd of spectators looked on. Each swing simultaneously generated
            stunning tennis-themed visuals and sound on a 30’ LED screen.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503195506/usopen-4.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503195507/usopen-5.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503195509/usopen-6.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Using a custom app and real-time image processing, we created
            digital portraits of every participant with their unique creation,
            enabling their artful swings to live on in social media and beyond.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170508211747/usopen-7.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170508211749/usopen-9.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170508211751/usopen-10.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="swing-analysis">Swing Analysis</h2>
          <p>
            At the more intimate “Swing Analysis” session, card members met with
            a pro instructor, and then showed off their improved swing for a
            one-of-a-kind portrait session. Stroboscopic lighting and high-speed
            photography captured the path of their swings, appearing as trails
            of lights thanks to a custom-built LED racquet.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170508212139/usopen-12.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503195526/usopen-14.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>
              Largest ever Amex Fan Experience, attracting more than 14,000
              participants.
            </li>
            <li>100% attendance.</li>
            <li>600% social media increase compared to previous year.</li>
            <li>Ex Awards - Best Use of Technology - Gold.</li>
            <li>
              Featured in{' '}
              <a href="https://www.amazon.com/Experiential-Marketing-Secrets-Strategies-Greatest/dp/1119145872/" target="_blank" rel="noopener">
                <em>Experiential Marketing</em>
              </a>{' '}
              by Kerry Smith and Dan Hanover
            </li>
          </ul>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            Momentum
            <br />
            Red Paper Heart
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Experience Mapping',
                  'Prototyping & Validation',
                  'Technical Strategy'
                ]
              },

              {
                title: 'Design',
                items: [
                  '3D Animation',
                  '3D Design',
                  'Art Direction',
                  'Motion Design',
                  'Sound Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Functional Prototyping',
                  'Systems Architecture'
                ]
              },

              {
                title: 'Delivery',
                items: ['Quality Assurance', 'Staff Training & Support']
              },

              {
                title: 'Experiential',
                items: [
                  'Custom Hardware',
                  'Hardware Specification',
                  'Immersive Environment',
                  'Installation Prototyping',
                  'Interactive Environment'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default AmericanExpress;
